<div class="modal" [ngClass]="{ 'open': isOpen }">
  <div class="modal-container" [ngStyle]=" {'display':showNegotiationModal ? 'none' : ''}">
    <h2 class="modal-title">{{'busca_inversu' | transloco}}
      <img src="assets/favicon.ico" width="56" alt="inversu">
      <button type="button" class="close" aria-label="Fechar" (click)="closeModal()">
        <span aria-hidden="true">×</span>
      </button>
    </h2>
    <div class="chat-content">
      <div class="message-history" #messageHistory>
        <div *ngFor="let message of messages" class="message"
          [ngClass]="{'user-message': message.sender === 'user', 'responder-message': message.sender === 'responder'}">
          <ng-container *ngIf="message.type === 'text'">
            <span class="text-user" [style.white-space]="'pre-line'">{{ message.text }}</span>
          </ng-container>
          <ng-container *ngIf="message.type === 'products'">
            <div class="container-fluid">
              <div class="col-lg-8 col-xl-9 order-lg-first">
                <div class="row row-40">
                  <div class="col-sm-6 col-md-4 col-lg-6 col-xl-4" *ngFor="let produto of message.products"
                    role="button">
                    <div class="profile-classic">
                      <div class="image-container">
                        <img [src]="produto.imagem?.url ? produto.imagem?.url : defaultImage" alt="{{produto.nome}}" />
                        <input type="checkbox" [(ngModel)]="produto.selected" (change)="onCheckboxChange(produto)"
                          class="checkbox-overlay" />
                      </div>
                      <hr>
                      <div class="profile-classic-main">
                        <ul class="profile-classic-list">
                          <li><span class="text-dark">{{produto.nome?.length >= 86 ? produto.nome.substring(0, 83)+'...'
                              : produto.nome}}</span></li>
                        </ul>
                        <p class="pt-2"><span>{{produto.negociacoes_ativas}} {{'negociacoes' | transloco}}</span></p>
                        <app-rating (click)="avaliacoes(produto)" [rating]="produto.rating"
                          [avaliacoes]="67"></app-rating>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <ng-container *ngIf="!afterSearched">
        <div class="input-container">
          <input type="text" [(ngModel)]="newMessage" (keyup.enter)="sendMessage()" placeholder="{{'pergunta_busca' | transloco}}" class="message-input" />
          <button type="button" mat-raised-button color="primary" (click)="sendMessage()" [disabled]="!newMessage.trim()">
            {{'enviar' | transloco}}
          </button>
        </div>
      </ng-container>
    </div>
    <div class="dialog-actions">
      <button type="button" mat-button (click)="closeModal()">{{ 'cancelar' | transloco }}</button>
      <button type="button" mat-raised-button (click)="queroComprar(messages[1]?.products)" [disabled]="!afterSearched"
        color="primary">
        {{'fazer_negociacao' | transloco}}
      </button>
    </div>
  </div>
</div>
<app-adiciona-negociacao-composta *ngIf="showNegotiationModal" [initialProducts]="productsToNegotiate"
  (closed)="onNegotiationModalClosed()"></app-adiciona-negociacao-composta>
